<template>
    <div class="table-page" v-if="loaded">
        <my-table ref="table" :name="pageKey" :cols="cols" :data="list" :loading="loading" :page-param="page"
                  :batch="batch" :operate="operate"
                  @sort="sort"
                  @init="init" @refresh="getList" @pageChange="pageChange" @paramChange="paramChange" @cndClusterChange="cndClusterChange">
            <template #right>
                <el-button class="btn-blue" plain icon="el-icon-plus" @click="add" :disabled="'M_SM_USR_I'|auth">添加</el-button>
                <el-button class="btn-blue" plain icon="el-icon-setting" @click="roleShow">角色</el-button>
            </template>
        </my-table>

        <common-add ref="add" :dialog="editDialog" :cols="cols" @save="editSave" @delEdit="delEdit"></common-add>
        <common-detail :dialog="detailDialog" :cols="cols" @save="editSave"></common-detail>

        <!--角色弹窗-->
        <my-dialog :show.sync="role.show" :loading="role.loading" :title="`${current.userName} - 分配角色`"
                         @save="roleSave" width="1000px">
          <el-row type="flex" justify="center" align="middle" class="transfer small-table">
            <el-col :span="11">
              <ls-admin-table ref="leftTable" :columns="role.left.columns" :data="role.left.list" :pageParam="role.left.query"
                              pageLayout="total, sizes, prev, pager, next" :loading="role.left.loading"
                              @handleSizeChange="handleLeftSizeChange"
                              @handleCurrentChange="handleLeftCurrentChange"
                              style="height: 500px;"></ls-admin-table>
            </el-col>
            <el-col :span="2" style="text-align:center">
              <i class="el-icon-arrow-right ls-middle-arrow" @click="transfer"></i>
            </el-col>
            <el-col :span="11" style="position:relative;align-self:flex-start">
              <ls-admin-table :columns="role.right.columns" :data="role.right.list" hide-multiple hide-page
                              style="height: 500px;">
                <template v-slot:slot_operate="data">
                  <el-button type="text" size="mini" @click="removeRole(data.$index)">移除</el-button>
                </template>
              </ls-admin-table>
            </el-col>
          </el-row>
        </my-dialog>

    </div>
</template>

<script>
    import myMixin from '@/util/myMixin';
    import tableMixin from '@/util/tableMixin';
    import adminHelp from '@/util/adminHelp';


    export default {
        mixins: [tableMixin, myMixin],
        data() {
            return {
                loaded:true,
                pageKey: 'user',
                api: {
                    list: 'sys/user/findUserPage',   // 列表接口
                    detail: 'sys/user/findUserByPk', // 详情接口
                    add: 'sys/user/insertUser',      // 新增接口
                    update: 'sys/user/updateUser',   // 修改接口
                    del: 'sys/user/deleteUser',      // 删除接口
                },

                operate: [
                    {txt: '修改', auth: 'M_SM_USR_E', type: 'primary', icon: 'el-icon-edit', event: this.update},
                    {txt: '详情', auth: '', type: 'success', icon: 'el-icon-view', event: this.detail},
                    {txt: '删除', auth: 'M_SM_USR_D', type: 'danger', icon: 'el-icon-circle-close', event: this.del},
                ],

                // 批量操作的参数
                batch: [
                    {txt: '批量删除', api: 'sys/user/deleteUserList', power:'delete',auth:'M_SM_USR_D'},
                ],
                cols: [
                    {
                        key: "userCode",
                        value: "用户账号",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "userName",
                        value: "用户名称",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "picUrl",
                        value: "用户头像",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                        type: this.$variable.colType.IMG,
                    },
                    {
                        key: "phone",
                        value: "手机号码",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "password",
                        value: "密码",
                        searchNormal: false,    // 允许普通筛选
                        searchAdvance: false,   // 允许高级筛选
                        viewList: false,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:false,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "remark",
                        value: "备注",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: true,         // 新增可现实
                        viewEdit: true,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 200,            // 宽度
                    },
                    {
                        key: "makeName",
                        value: "创建人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        viewDetail:true,        // 详情
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                     {
                        key: "makeTime",
                        value: "创建时间",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: false,
                        viewEdit: false,
                        minWidth: 150,
                        type: this.$variable.colType.DATE,
                    },
                    {
                        key: "modifyName",
                        value: "修改人",
                        searchNormal: true,    // 允许普通筛选
                        searchAdvance: true,   // 允许高级筛选
                        viewList: true,        // 列表可现实
                        viewAdd: false,         // 新增可现实
                        viewEdit: false,        // 修改可现实
                        //minWidth: 200,       // 默认宽度200，但是可以扩大到占满表格
                        width: 150,            // 宽度
                    },
                    {
                        key: "modifyTime",
                        value: "修改时间",
                        searchNormal: true,
                        searchAdvance: true,
                        viewList: true,
                        viewAdd: false,
                        viewEdit: false,
                        minWidth: 150,
                        type: this.$variable.colType.DATE,
                    },
                ],
                role: adminHelp.getDialog('', {
                  title: '分配角色',
                  handle: 'sys/userRole/insertUserRoles',
                  left: {
                    loading: false,
                    list: [],
                    query: adminHelp.getPage(),
                    columns: [
                      {name: 'roleCode', value: '角色编号', width: 100},
                      {name: 'roleName', value: '角色名称', width: 100}
                    ],
                  },
                  right: {
                    list: [],
                    columns: [
                      {name: 'operate', value: '', width: 100},
                      {name: 'roleCode', value: '角色编号', width: 100},
                      {name: 'roleName', value: '角色名称', width: 100}
                    ],
                  },
                }),

                current: {},
            }
        },
        methods: {
          // 角色弹窗
          roleShow() {
            const select = this.$refs.table.$refs.table.selection
            if (select.length === 1) {
              this.current = select[0]
              adminHelp.showDialog(this.role)
              this.loadRoleLeft()
              this.loadRoleRight()
            } else {
                 this.$help.error('请先选择有效记录，再执行该操作。')
            }
          },

          roleSave() {
              let arr = []
              this.role.right.list.forEach(item => {
                arr.push(item.id)
              })
                 this.$api.post('sys/userRole/insertUserRoles', {
                  userId: this.current.id,
                  roleIdList: arr
              })
               .then(res => {
                     this.$help.success(res.msg)
                     this.role.show = false
                   })
               .catch(error => {
                     this.$help.error(error.error || error.obj)
                 })
               .finally(() => {
                     this.role.show = false
               })
            },
            loadRoleLeft() {
              this.role.left.query.roleType = this.current.userType
              this.role.left.loading = true
              this.$api.post('sys/role/findRolePage',this.role.left.query)
                .then(res => {
                  this.role.left.list = res.records
                  this.role.left.query.total = res.total
                })
                .finally(() => {
                  this.role.left.loading = false
                })
            },
            loadRoleRight() {
            this.$api.post('sys/role/selectRoleByUserId',{userId:this.current.id})
                .then(res => {
                  this.role.right.list = res
                })
            },
            handleLeftSizeChange(val) {
                this.role.left.query.size = val
                this.role.left.query.current = 1
                this.loadRoleLeft()
              },
              handleLeftCurrentChange(val) {
                if (typeof val === 'number') {
                  this.role.left.query.current = val
                  this.loadRoleLeft()

                }
              },
              transfer() {
                  this.$refs.leftTable.$refs.datatable.selection.forEach(item => {
                    let flag = false
                    for (let i = 0; i < this.role.right.list.length; i += 1) {
                      if (item.id === this.role.right.list[i].id) {
                        flag = true
                      }
                    }
                    !flag && this.role.right.list.push(item)
                  })
                },
                removeRole(index) {
                  this.role.right.list.splice(index, 1)
                },
        },
        created() {
            // 枚举类型查询
            let dataCode = [];
            for (let i = 0; i < this.cols.length; i++) {
                if (this.cols[i].param && this.cols[i].param.dict) {
                    dataCode.push(this.cols[i].param.dict);
                }
            }
            if (dataCode.length !== 0) {
                this.$api.post('sys/dict/selectDictItemMap', dataCode)
                    .then(res => {
                        for (let i = 0; i < this.cols.length; i++) {
                            if (this.cols[i].param && this.cols[i].param.dict) {
                                let keyValue = {};
                                if(res[this.cols[i].param.dict]){
                                    for (let j = 0; j< res[this.cols[i].param.dict].length; j++){
                                        keyValue[res[this.cols[i].param.dict][j].itemDataCode] = res[this.cols[i].param.dict][j].itemDataName;
                                    }
                                    this.cols[i].param.keyValue = keyValue;
                                }
                            }
                        }
                        this.loaded = false;
                        this.$nextTick(() => {this.loaded = true});
                    });
            }
            //按钮权限查询

        },
    }
</script>
